import API from "serviceshift-ui/api-client";
import { setCollectionItem } from "@/lib/collections";
import { authenticityToken } from "@/lib/helpers";

export default {
  async destroyBatch(_, { url }) {
    const res = await API.makeRequest(url, {
      method: "DELETE",
      contentType: "application/json",
      headers: { "X-CSRF-Token": authenticityToken() }
    });

    return res.data;
  },
  async fetchBatchItem({ commit }, { url }) {
    const res = await API.makeRequest(url, {
      method: "GET",
      contentType: "application/json",
      headers: { "X-CSRF-Token": authenticityToken() }
    });

    const { data } = res;

    setCollectionItem("batchItems", data.batchItemId, data);

    return data;
  }
};
